import { ApiHttpService } from '../../services'
export const SapItemMasterModule = {
    namespaced: true,
    state: {
        request: null,
        loading : false,
       

    },
    mutations: {
        addRequest : (state, req) => {
            state.request = {cancel : req.cancel, msg : "loading"}

        },
        cancelRequest : (state) => {

            if(state.request != null){
                state.request.cancel()
            }
            state.loading = true
        },
        clearOldRequest(state, message) {
            state.request.msg = message;
            state.request = null;
        },
       
        loadingTrue(state) {
            state.loading = true
        },
        setLoading(state, payload) {
            state.loading = payload
        },
    },
    actions : {
        async getRecord(_,obj) {
            return await new Promise((resolve, reject) => {
                ApiHttpService.getRequest('item-master/oitm',obj).then((response) => {
                    resolve(response.data)
                }).catch(error => {
                    reject(error)
                })
            })
        },
    },
    getters: {
        req: state => state.request,
        loading : state => state.loading,
    }
}



